import React from 'react';
import { PropTypes } from 'prop-types';
import {observer} from 'mobx-react';

@observer
export class NewAppSubmit extends React.Component {

	static propTypes = {
		store: PropTypes.object.isRequired,
		userName: PropTypes.string.isRequired
	};

	constructor(props) {
		super(props);
		this.store = this.props.store;
	}

	onAgreeChange = (event) => {
		this.store.toggleReadAndAgree(event.target)
	};

	render () {
		const userName = this.props.userName;
		const companyName = this.store.newAppData.authorName;
		const appName = this.store.newAppData.appName;
		return(
			<div className="new-app-submit">
				<div className="container">
					<h2>Submit for Approval</h2>
					<div className="row">
						<div className="col-10">
							<p className="as-intro-text">App Submission Policy:</p>
							<p>I, {userName}, on behalf of myself and/or {companyName} am submitting {appName} to the FirstNet App Review Process for review and potential listing on the FirstNet App Catalog. I hereby attest that I have full authority to submit this app for consideration and review and that I am not infringing upon or violating any other person&apos;s ownership interest in the app by doing so. I understand that approval or rejection of the app is at the sole discretion of the FirstNet App Review Team.</p>
							<p>I have reviewed the processes, submission guidelines, and policies available on the FirstNet Developer Portal and App Control*.</p>
							<form>
								<div className="checkbox">
									<label>
										<input type="checkbox" checked={this.store.masterStateProps.userAgreedToTerms} onChange={this.onAgreeChange}/>
										<span className="cr"></span>
										<strong>Acknowledgment of terms *<br/>I acknowledge that I have read and agree to the submission guidelines listed on the FirstNet Developer Portal.</strong>
									</label>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		);
	}

}
